interface LogbookItem {
  lbname?: string;
  lbid?: string;
}
interface RawLogbookItem extends LogbookItem {
  colid?: string;
  colname?: string;
  list?: LogbookItem[];
}
/**
 * Maps raw logbook data into a format suitable for selection components.- used in summary
 *
 * @param logbooks - An array of raw logbook items to be mapped.
 * @returns An array of logbooks formatted for selection, including groups and labels.
 */
export const mapLogbookSelect = (logbooks: RawLogbookItem[]) => {
  const selectLogs: any[] = [];
  const itemParser = (item: RawLogbookItem, group?: string) => ({
    label: item.lbname,
    value: item.lbid,
    group: group ?? "All Logbooks",
  });
  logbooks.forEach(logbook => {
    if (logbook.lbname) {
      selectLogs.push(itemParser(logbook));
    } else if (logbook.colname) {
      // selectLogs.push({
      //   label: logbook.colname,
      //   value: logbook.colid,
      //   disabled: true,
      // });
      logbook.list?.forEach(item => {
        selectLogs.push(itemParser(item, logbook.colname));
      });
    }
  });
  selectLogs.unshift({
    label: "All Logbooks",
    value: "*",
    group: "All Logbooks",
  });
  return selectLogs;
};
